// FormPage.js
// import { withRouter } from "react-router-dom";
import React, { useState } from "react";
import {
  Form,
  Table,
  Button,
  Row,
  Col,
  InputNumber,
  Select,
  Slider,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";

import "./FormPage.css";
// var myChart = echarts.init(document.getElementById('main'));

// const ageMarks = {
//   20: 20,
//   25: 25,
//   30: 30,
//   35: 35,
//   40: 40,
//   45: 45,
//   50: 50,
//   55: 55,
//   60: 60,
//   65: 65,
//   70: 70,
//   75: 75,
//   80: 80,
//   85: 85
// }
const columns = [
  {
    title: "时间",
    dataIndex: "time",
    key: "time",
  },
  {
    title: "风险",
    dataIndex: "risk",
    key: "risk",
  },
];
const FormPage = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState(null);
  const [age, setAge] = useState();
  const [loading, setLoading] = useState(false);

  const onAgeChange = (value) => {
    if (isNaN(value)) {
      return;
    }
    setAge(value);
  };
  const onFinish = async () => {
    const values = await form.validateFields();
    values.age = age;
    setLoading(true);
    console.log(values);
    axios
      // .post("http://www.breastcancerriskpredict.cn/predict", {
      .post("https://fbcc.bjcancer.org.cn/predict", {
        ...values,
      })
      .then(function (response) {
        setLoading(false);
        const { data } = response;
        setData(data);
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
      });
  };

  return (
    <div className="form-page-wrap">
      <h2>对侧乳腺癌风险预测</h2>

      <Form form={form} name="form" onFinish={onFinish}>
        <Form.Item
          name="age"
          label="输入患病年龄"
          rules={[{ required: true, message: "请选输入患病年龄" }]}
        >
          <Row>
            <InputNumber
              min={20}
              max={85}
              step={1}
              value={age}
              onChange={onAgeChange}
            />
          </Row>
        </Form.Item>
        <Form.Item
          name="family_history"
          label="是否有家族遗传史"
          rules={[{ required: true, message: "请选择是否有家族遗传史" }]}
          style={{ maxWidth: "350px" }}
        >
          <Select
            placeholder="请选择"
            options={[
              { value: 1, label: "是" },
              { value: 0, label: " 否" },
            ]}
          />
        </Form.Item>

        <Form.Item
          name="endocrine_therapy"
          label="是否使用内分泌治疗"
          rules={[{ required: true, message: "请选择是否使用内分泌治疗" }]}
          style={{ maxWidth: "350px" }}
        >
          <Select
            placeholder="请选择"
            options={[
              { value: 1, label: "是" },
              { value: 0, label: " 否" },
            ]}
          />
        </Form.Item>
        <Form.Item
          name="mutation_location"
          label="基因突变位置"
          rules={[{ required: true, message: "请选择基因突变位置" }]}
          style={{ maxWidth: "350px" }}
        >
          <Select
            placeholder="请选择"
            options={[
              { value: 0, label: "3'-端区域内" },
              { value: 1, label: "3'-端区域外" },
            ]}
          />
        </Form.Item>
        <p className="des">「BRCA1 3'-端区域内」是指位点从C.4072到3'端 </p>
        <p className="des">「BRCA1 3'-端区域外」是指位点从5'端到C.4071 </p>
        <p className="des">「BRCA2 3'-端区域内」是指位点从C.6402到3'端 </p>
        <p className="des" style={{ marginBottom: "20px" }}>
          「BRCA2 3'-端区域外」是指位点从5'端到C.6401{" "}
        </p>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            开始预测
          </Button>
        </Form.Item>
        {loading ? (
          <LoadingOutlined />
        ) : (
          <>
            {data && (
              <>
                <h3 className="des">预测结果： </h3>

                <p className="des">5年累积风险：{data.risk5}</p>
                <p className="des" style={{ marginBottom: "20px" }}>
                  10年累积风险：{data.risk10}
                </p>
                <h3 className="des">更多数据：</h3>

                <Table
                  dataSource={data.detailRisk}
                  columns={columns}
                  pagination={false}
                />
              </>
            )}
          </>
        )}
      </Form>
      <footer className="footer">
        <div className="footer-left">
          <p>
            如果您在使用中有什么问题，可以用微信扫描下方二维码，咨询北肿家族遗传性肿瘤中心姚老师或者张老师
          </p>
          <img
            src="https://pic1.zhimg.com/v2-b1108d5983c6426dc8a1097cdd87ec71.png"
            className="qrcode"
          ></img>
          <p className="wechat">微信号：bjcancerfhtc</p>
          <p className="beian">京ICP备2023014626号</p>
        </div>
      </footer>
    </div>
  );
};

export default FormPage;
